import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const AdminRoutes = React.lazy(() => import('@/pages/SUPPORTPAGES/AdminRoutes'))
const CategoryFunctionManagement = React.lazy(
  () => import('@/features/category-function/container/CategoryFunctionManagement')
)

const Role = React.lazy(() => import('@/features/role/pages'))
const ProductPage = React.lazy(() => import('@/pages/ADMIN/Product'))
const BusinessFieldList = React.lazy(
  () => import('@/features/business-field/pages/BusinessFieldList')
)
const ProductCategoryList = React.lazy(
  () => import('@/features/product-category/pages/ProductCategoryList')
)
const UnitList = React.lazy(() => import('@/features/unit/pages/UnitList'))
const LocationList = React.lazy(() => import('@/features/location/pages/LocationList'))
const ProvinceList = React.lazy(() => import('@/features/province/pages/ProvinceList'))
const WardList = React.lazy(() => import('@/features/ward/pages/WardList'))
const OrganizationListContainer = React.lazy(
  () => import('@/features/organization/container/OrganizationListContainer')
)
const PartnerList = React.lazy(() => import('@/features/partner/container/PartnerListContainer'))
const SystemConnectList = React.lazy(
  () => import('@/features/system-connect/pages/SystemConnectList')
)
const CommonSettingList = React.lazy(
  () => import('@/features/common-setting/pages/CommonSettingList')
)
const CompanyPage = React.lazy(() => import('@/pages/ADMIN/Company'))
const ComingSoonPage = React.lazy(() => import('@/pages/ADMIN/ComingSoon'))
const SystemLogList = React.lazy(() => import('@/features/system-log'))
const ProductOcopList = React.lazy(() => import('@/features/product-ocop'))
const SettingsCommonsList = React.lazy(() => import('@/features/settings-commons'))
const StaffRegistrationPage = React.lazy(() => import('@/features/staff-registration'))
const ProductOcopRegisterList = React.lazy(() => import('@/features/product-ocop-register'))
const ProductPromotionList = React.lazy(() => import('@/features/product-promotion'))
const EmployeeList = React.lazy(() => import('@/features/employee/pages/EmployeeList'))
const CompanyRegisterPage = React.lazy(() => import('@/pages/ADMIN/CompanyRegister'))
const ProductRegisterList = React.lazy(
  () => import('@/features/product-register/container/ProductRegisterListContainer')
)
const ProductPromotionRegisterList = React.lazy(
  () => import('@/features/product-promotion-register')
)
const SupplyDemandPage = React.lazy(() => import('@/pages/ADMIN/SupplyDemand'))
const OrderList = React.lazy(() => import('@/features/order'))
const QrCodeRegisterList = React.lazy(() => import('@/features/qrcode-register'))
const QrCodeList = React.lazy(() => import('@/features/qrcode'))
const HygieneSafetyList = React.lazy(() => import('@/features/hygiene-safety'))
const ProductionZoneList = React.lazy(() => import('@/features/production-zone'))
const ProductSupplyChainList = React.lazy(() => import('@/features/product-supply-chain'))
const ProductionOrderList = React.lazy(() => import('@/features/production-order'))
const ProductDiaryList = React.lazy(() => import('@/features/product-diary'))
const MenuList = React.lazy(() => import('@/features/menu'))
const QrCodeReportList = React.lazy(() => import('@/features/qrcode-report'))
const ProductReportList = React.lazy(() => import('@/features/product-report'))
const CompanyReportList = React.lazy(() => import('@/features/company-report'))
const DashboardList = React.lazy(() => import('@/features/dashboard'))
const ProductStatisticReportPage = React.lazy(
  () => import('@/pages/ADMIN/EnterpriseReport/ProductStatistic')
)
const SupplyDemandReportPage = React.lazy(
  () => import('@/pages/ADMIN/EnterpriseReport/SupplyDemandReport')
)
const SaleOrderReportPage = React.lazy(
  () => import('@/pages/ADMIN/EnterpriseReport/SaleOrderReport')
)
const ProductionOrderReportPage = React.lazy(
  () => import('@/pages/ADMIN/EnterpriseReport/ProductionOrderReport')
)
const QrCodeReportPage = React.lazy(() => import('@/pages/ADMIN/EnterpriseReport/QrCodeReport'))
const ProductReportPage = React.lazy(() => import('@/pages/ADMIN/EnterpriseReport/ProductReport'))
const PartnerReportPage = React.lazy(() => import('@/pages/ADMIN/EnterpriseReport/PartnerReport'))
const EnterpriseCompanyReportPage = React.lazy(
  () => import('@/pages/ADMIN/EnterpriseReport/EnterpriseCompanyReport')
)

// categoryID xác nhận thật từ GetListTab chưa có feature build ở FE mới → route tới ComingSoon,
// đủ để menu/route click đúng chỗ; thay bằng feature thật khi tới lượt module đó.
const COMING_SOON_ROUTES = []

export const adminRoutes = [
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AdminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.QUAN_LY_PHAN_QUYEN,
        element: (
          <LazyLoadingComponent>
            <Role />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_DANH_MUC_CHUC_NANG,
        element: (
          <LazyLoadingComponent>
            <CategoryFunctionManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PRODUCT,
        element: (
          <LazyLoadingComponent>
            <ProductPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LINH_VUC_KINH_DOANH,
        element: (
          <LazyLoadingComponent>
            <BusinessFieldList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LINH_VUC_HOAT_DONG,
        element: (
          <LazyLoadingComponent>
            <BusinessFieldList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_MUC_SAN_PHAM,
        element: (
          <LazyLoadingComponent>
            <ProductCategoryList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DON_VI_DO_LUONG,
        element: (
          <LazyLoadingComponent>
            <UnitList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DIA_GIOI_HANH_CHINH,
        element: (
          <LazyLoadingComponent>
            <LocationList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TINH_THANH,
        element: (
          <LazyLoadingComponent>
            <ProvinceList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.XA_PHUONG,
        element: (
          <LazyLoadingComponent>
            <WardList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DON_VI_QUAN_LY,
        element: (
          <LazyLoadingComponent>
            <OrganizationListContainer />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DOI_TAC,
        element: (
          <LazyLoadingComponent>
            <PartnerList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THIET_LAP_KET_NOI,
        element: (
          <LazyLoadingComponent>
            <SystemConnectList />
          </LazyLoadingComponent>
        ),
      },
      {
        // tách riêng khỏi CAI_DAT_CHUNG (màn Cài đặt chung thật / mã tiền tố)
        path: ROUTER.CAI_DAT_LICH_LAM_VIEC,
        element: (
          <LazyLoadingComponent>
            <CommonSettingList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <CompanyPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_NGUOI_DUNG,
        element: (
          <LazyLoadingComponent>
            <EmployeeList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <CompanyRegisterPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_SAN_PHAM,
        element: (
          <LazyLoadingComponent>
            <ProductRegisterList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_KHUYEN_MAI,
        element: (
          <LazyLoadingComponent>
            <ProductPromotionRegisterList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CUNG_CAU,
        element: (
          <LazyLoadingComponent>
            <SupplyDemandPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DON_HANG,
        element: (
          <LazyLoadingComponent>
            <OrderList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_MA_TEM,
        element: (
          <LazyLoadingComponent>
            <QrCodeRegisterList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_MA_TEM,
        element: (
          <LazyLoadingComponent>
            <QrCodeList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.AN_TOAN_SAN_XUAT,
        element: (
          <LazyLoadingComponent>
            <HygieneSafetyList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.VUNG_SAN_XUAT,
        element: (
          <LazyLoadingComponent>
            <ProductionZoneList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHUOI_CUNG_UNG,
        element: (
          <LazyLoadingComponent>
            <ProductSupplyChainList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DON_SAN_XUAT,
        element: (
          <LazyLoadingComponent>
            <ProductionOrderList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NHAT_KY_SAN_PHAM,
        element: (
          <LazyLoadingComponent>
            <ProductDiaryList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_MENU,
        element: (
          <LazyLoadingComponent>
            <MenuList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NHAT_KY_HE_THONG,
        element: (
          <LazyLoadingComponent>
            <SystemLogList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_TEM_NHAN,
        element: (
          <LazyLoadingComponent>
            <QrCodeReportList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BAO_CAO_SAN_PHAM,
        element: (
          <LazyLoadingComponent>
            <ProductReportList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BAO_CAO_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <CompanyReportList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_SAN_PHAM,
        element: (
          <LazyLoadingComponent>
            <ProductStatisticReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_DON_SAN_XUAT,
        element: (
          <LazyLoadingComponent>
            <ProductionOrderReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_TEM_NHAN_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <QrCodeReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_DON_HANG,
        element: (
          <LazyLoadingComponent>
            <SaleOrderReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_CUNG_CAU,
        element: (
          <LazyLoadingComponent>
            <SupplyDemandReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BAO_CAO_SAN_PHAM_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <ProductReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.BAO_CAO_DOI_TAC,
        element: (
          <LazyLoadingComponent>
            <PartnerReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_DOANH_NGHIEP_DN,
        element: (
          <LazyLoadingComponent>
            <EnterpriseCompanyReportPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_TONG_QUAN,
        element: (
          <LazyLoadingComponent>
            <DashboardList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DASHBOARD,
        element: (
          <LazyLoadingComponent>
            <DashboardList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PRODUCT_PROMOTION,
        element: (
          <LazyLoadingComponent>
            <ProductPromotionList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PRODUCT_OCOP_REGISTER,
        element: (
          <LazyLoadingComponent>
            <ProductOcopRegisterList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.STAFF_REGISTRATION,
        element: (
          <LazyLoadingComponent>
            <StaffRegistrationPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CAI_DAT_CHUNG_TIEN_TO,
        element: (
          <LazyLoadingComponent>
            <SettingsCommonsList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PRODUCT_OCOP,
        element: (
          <LazyLoadingComponent>
            <ProductOcopList />
          </LazyLoadingComponent>
        ),
      },
      ...COMING_SOON_ROUTES.map((path) => ({
        path,
        element: (
          <LazyLoadingComponent>
            <ComingSoonPage />
          </LazyLoadingComponent>
        ),
      })),
    ],
  },
]
